import * as types from './mutation-types'
import { monitorClient } from '@/service/apiClients'

export default {
  async getMonitors ({ rootState, commit }) {
    try {
      const { data: monitors } = await monitorClient.get(`/users/${rootState.userModule.uid}/monitors`)
      commit(types.SET_MONITOR_LIST, monitors)
    } catch (e) {
      console.error(e)
    }
  },
  async updateMonitorSettings ({ state, rootState, commit }, { id, settings }) {
    const index = state.monitors.findIndex(m => m.id === id)
    if (~index) {
      commit(types.UPDATE_MONITOR_SETTINGS, { index, settings })
      try {
        await monitorClient.put(`/users/${rootState.userModule.uid}/monitors/${id}`, {
          name: state.monitors[index].name,
          settings: state.monitors[index].settings
        })
      } catch (e) {
        console.error(e.message)
      }
    }
  },
  async updateMonitorName ({ state, rootState, commit }, { id, name }) {
    const index = state.monitors.findIndex(m => m.id === id)
    if (~index) {
      commit(types.UPDATE_MONITOR_NAME, { index, name })
      try {
        await monitorClient.put(`/users/${rootState.userModule.uid}/monitors/${id}`, {
          name: state.monitors[index].name,
          settings: state.monitors[index].settings
        })
      } catch (e) {
        console.error(e.message)
      }
    }
  }
}
